import { FormattedMsg } from '@components/i18n/formattedMsg';
import { Layout } from 'antd';
import React from 'react';

interface IProps {
    name: string;
}

const FunderApplicantLayoutHeader: React.FunctionComponent<IProps> = ({ name }) => {
    return (
        <Layout
            style={{
                background: '#fff',
                paddingLeft: '32px',
                paddingRight: '32px',
            }}
        >
            <Layout.Content>
                <br />
                <FormattedMsg id='funder-applicant.layout-header.path' />
                <h4 style={{ paddingTop: '16px', paddingBottom: '16px' }} ><b><FormattedMsg id='common.welcome' />, {name}</b></h4>
                <FormattedMsg id='funder-applicant.layout-header.caption' />
            </Layout.Content>
        </Layout>
    )
}

export default FunderApplicantLayoutHeader;